import * as React from 'react';

type BookProps = {
  size?: number;
  color?: string;
};

export function Book({
  size = 18,
  color = '#191F2E',
}: BookProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.125 3.1809C2.1206 2.76491 3.54814 2.31676 4.93614 2.17676C6.43274 2.02581 7.7022 2.24773 8.4375 3.02243V13.9865C7.38575 13.3902 6.05323 13.3084 4.82324 13.4324C3.49529 13.5664 2.15742 13.9512 1.125 14.3448V3.1809ZM9.5625 3.02243C10.2978 2.24773 11.5673 2.02581 13.0639 2.17676C14.4519 2.31676 15.8794 2.76491 16.875 3.1809V14.3448C15.8426 13.9512 14.5047 13.5664 13.1768 13.4324C11.9468 13.3084 10.6143 13.3902 9.5625 13.9865V3.02243ZM9 2.00583C7.89197 1.05341 6.28518 0.909981 4.82324 1.05744C3.11987 1.22925 1.40016 1.81378 0.329736 2.30033C0.128927 2.39161 0 2.59183 0 2.81241V15.1874C0 15.3787 0.0971731 15.5568 0.257971 15.6604C0.418768 15.7639 0.621157 15.7786 0.795264 15.6995C1.78734 15.2486 3.38638 14.7081 4.93614 14.5518C6.52011 14.392 7.84965 14.6499 8.56076 15.5388C8.66751 15.6722 8.82912 15.7499 9 15.7499C9.17088 15.7499 9.33249 15.6722 9.43924 15.5388C10.1503 14.6499 11.4799 14.392 13.0639 14.5518C14.6136 14.7081 16.2127 15.2486 17.2047 15.6995C17.3788 15.7786 17.5812 15.7639 17.742 15.6604C17.9028 15.5568 18 15.3787 18 15.1874V2.81241C18 2.59183 17.8711 2.39161 17.6703 2.30033C16.5998 1.81378 14.8801 1.22925 13.1768 1.05744C11.7148 0.909981 10.108 1.05341 9 2.00583Z"
        fill={color}
      />
    </svg>
  );
}
